import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IPriceListServices, ICity, IRealEstateClass } from './interfaces';

const BASE_URL = '/calculatorTariff/priceListServices';

export const getPriceListServicesList = (params: IDynamicTableParams): Promise<IPriceListServices[]> => {
  return instance()
    .post(`${BASE_URL}/list`, params)
    .then((response) => response.data);
};

export const getPriceListServicesAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post(`${BASE_URL}/availableColumns`)
    .then((response) => response.data);
};

export const getPriceListServicesAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post(`${BASE_URL}/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadPriceListServices = (priceListServicesId: number): Promise<IPriceListServices> => {
  return instance()
    .get<IPriceListServices>(`${BASE_URL}/load/${priceListServicesId}`)
    .then((response) => response.data);
};

export const createPriceListServices = (priceListServices: IPriceListServices): Promise<IPriceListServices> => {
  return instance()
    .post<IPriceListServices>(`${BASE_URL}/save`, priceListServices)
    .then((response) => response.data);
};

export const updatePriceListServices = (priceListServices: IPriceListServices): Promise<IPriceListServices> => {
  return instance()
    .post<IPriceListServices>(`${BASE_URL}/${priceListServices.priceListServicesId}/update`, priceListServices)
    .then((response) => response.data);
};

export const deletePriceListServices = (priceListServicesId: number): Promise<void> => {
  return instance()
    .post(`${BASE_URL}/archive`, { priceListServicesId })
    .then((response) => response.data);
};

export const recoverPriceListServices = (priceListServicesId: number): Promise<void> => {
  return instance()
    .post(`${BASE_URL}/recover`, { priceListServicesId })
    .then((response) => response.data);
};

export const getCitiesList = (): Promise<ICity[]> => {
  return instance()
    .post<ICity[]>('/city/list', {})
    .then((response) => response.data);
};

// SERVICE-5135: все классы жилья для панели «Классы»
export const getRealEstateClasses = (): Promise<IRealEstateClass[]> => {
  return instance()
    .get<IRealEstateClass[]>('/calculatorTariff/realEstateClass/search', { params: { search: '' } })
    .then((response) => response.data);
};
